// src/components/ui/BottomNav.js
import React from 'react';
import { LayoutDashboard, Users, UserX, IndianRupee, ClipboardList, UserPlus } from 'lucide-react';
import './ui.css';

const BottomNav = ({ view, setView, setShowGuideModal, handleVoiceClick, activeGuideFlow }) => {
    return (
        <div style={{ 
            position: 'fixed', bottom: 0, left: 0, width: '100%', 
            background: '#0F172A', /* 🌟 Premium Dark Blue Background */
            borderTop: '1px solid rgba(255, 255, 255, 0.08)', 
            display: 'flex', justifyContent: 'space-around', 
            padding: '10px 0 16px 0', 
            zIndex: activeGuideFlow ? 10 : 1000, 
            boxShadow: '0 -10px 30px rgba(0,0,0,0.5)', /* 🌟 Deep Shadow */
            backdropFilter: 'blur(10px)'
        }}>
            
            {/* HOME */}
            <div onClick={(e) => handleVoiceClick(
                e, " ye home dashbaord page hai, ismein aap apne textile karkhane ki production details dekh sakte hain,", 
                () => { setView('dashboard'); setShowGuideModal(false); },
                'nav-home', view === 'dashboard', 
                " aap abhi home dashboard page par hain, ismein aap apne textile karkhane ki production details dekh sakte hain."
            )} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', cursor: 'pointer', transition: 'all 0.2s', transform: view === 'dashboard' ? 'translateY(-2px)' : 'none' }}>
                <div style={{ 
                    background: view === 'dashboard' ? 'rgba(99, 102, 241, 0.15)' : 'transparent', 
                    border: view === 'dashboard' ? '1px solid rgba(99, 102, 241, 0.3)' : '1px solid transparent',
                    padding: '6px 14px', borderRadius: '14px', transition: 'all 0.3s ease', 
                    boxShadow: view === 'dashboard' ? '0 4px 10px rgba(99, 102, 241, 0.2)' : 'none' 
                }}>
                    <LayoutDashboard size={20} color={view === 'dashboard' ? '#818CF8' : '#64748B'} strokeWidth={view === 'dashboard' ? 2.5 : 2} />
                </div>
                <span style={{ fontSize: '9px', color: view === 'dashboard' ? '#818CF8' : '#64748B', fontWeight: '700', letterSpacing: '0.3px', textTransform: 'uppercase' }}>Home</span>
            </div>
            
            {/* WORKERS */}
            <div onClick={(e) => handleVoiceClick(
                e, " ye Workers page button hai, ismein aap apne textile karkhane ke workers ki details dekh sakte hain,", 
                () => { setView('workers'); setShowGuideModal(false); },
                'nav-workers', view === 'workers', 
                " aap abhi workers page par hain, ismein aap apne textile karkhane ke workers ki details dekh sakte hain."
            )} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', cursor: 'pointer', transition: 'all 0.2s', transform: view === 'workers' ? 'translateY(-2px)' : 'none' }}>
                <div style={{ 
                    background: view === 'workers' ? 'rgba(56, 189, 248, 0.15)' : 'transparent', 
                    border: view === 'workers' ? '1px solid rgba(56, 189, 248, 0.3)' : '1px solid transparent',
                    padding: '6px 14px', borderRadius: '14px', transition: 'all 0.3s ease', 
                    boxShadow: view === 'workers' ? '0 4px 10px rgba(56, 189, 248, 0.2)' : 'none' 
                }}>
                    <Users size={20} color={view === 'workers' ? '#38BDF8' : '#64748B'} strokeWidth={view === 'workers' ? 2.5 : 2} />
                </div>
                <span style={{ fontSize: '9px', color: view === 'workers' ? '#38BDF8' : '#64748B', fontWeight: '700', letterSpacing: '0.3px', textTransform: 'uppercase' }}>Workers</span>
            </div>
            
            {/* BADLI LOG */}
            <div onClick={(e) => handleVoiceClick(
                e, " ye badli log page button hai, ismein aap apne textile karkhane ki badli production ki details dekh sakte hain,", 
                () => { setView('badli_history'); setShowGuideModal(false); },
                'nav-badli', view === 'badli_history', 
                " aap abhi badli log page par hain, ismein aap apne textile karkhane ki badli production ki details dekh sakte hain."
            )} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', cursor: 'pointer', transition: 'all 0.2s', transform: view === 'badli_history' ? 'translateY(-2px)' : 'none' }}>
                <div style={{ 
                    background: view === 'badli_history' ? 'rgba(245, 158, 11, 0.15)' : 'transparent', 
                    border: view === 'badli_history' ? '1px solid rgba(245, 158, 11, 0.3)' : '1px solid transparent',
                    padding: '6px 14px', borderRadius: '14px', transition: 'all 0.3s ease', 
                    boxShadow: view === 'badli_history' ? '0 4px 10px rgba(245, 158, 11, 0.2)' : 'none' 
                }}>
                    <UserX size={20} color={view === 'badli_history' ? '#FBBF24' : '#64748B'} strokeWidth={view === 'badli_history' ? 2.5 : 2} />
                </div>
                <span style={{ fontSize: '9px', color: view === 'badli_history' ? '#FBBF24' : '#64748B', fontWeight: '700', letterSpacing: '0.3px', textTransform: 'uppercase' }}>Badli Log</span>
            </div>
            
            {/* PAYMENTS */}
            <div onClick={(e) => handleVoiceClick(
                e, " ye payments page button hai, ismein aap apne textile karkhane ke workers ko salary aur advance ki payment de sakte hain,", 
                () => { setView('payments'); setShowGuideModal(false); },
                'nav-payments', view === 'payments', 
                " aap abhi pements page par hain, ismein aap apne textile karkhane ke workers ko salary aur advance ki payment de sakte hain."
            )} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', cursor: 'pointer', transition: 'all 0.2s', transform: view === 'payments' ? 'translateY(-2px)' : 'none' }}>
                <div style={{ 
                    background: view === 'payments' ? 'rgba(16, 185, 129, 0.15)' : 'transparent', 
                    border: view === 'payments' ? '1px solid rgba(16, 185, 129, 0.3)' : '1px solid transparent',
                    padding: '6px 14px', borderRadius: '14px', transition: 'all 0.3s ease', 
                    boxShadow: view === 'payments' ? '0 4px 10px rgba(16, 185, 129, 0.2)' : 'none' 
                }}>
                    <IndianRupee size={20} color={view === 'payments' ? '#34D399' : '#64748B'} strokeWidth={view === 'payments' ? 2.5 : 2} />
                </div>
                <span style={{ fontSize: '9px', color: view === 'payments' ? '#34D399' : '#64748B', fontWeight: '700', letterSpacing: '0.3px', textTransform: 'uppercase' }}>Payments</span>
            </div>
            
            {/* STOCK / INVENTORY */}
            <div onClick={(e) => handleVoiceClick(
                e, " ye stock page button hai, ismein aap apne textile karkhane ka production stock, yarn stock aur kharche dekh sakte hain,", 
                () => { setView('inventory'); setShowGuideModal(false); },
                'nav-stock', view === 'inventory', 
                " aap abhi stock page par hain, ismein aap apne textile karkhane ka production stock, yarn stock aur kharche dekh sakte hain."
            )} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', cursor: 'pointer', transition: 'all 0.2s', transform: view === 'inventory' ? 'translateY(-2px)' : 'none' }}>
                <div style={{ 
                    background: view === 'inventory' ? 'rgba(236, 72, 153, 0.15)' : 'transparent', 
                    border: view === 'inventory' ? '1px solid rgba(236, 72, 153, 0.3)' : '1px solid transparent',
                    padding: '6px 14px', borderRadius: '14px', transition: 'all 0.3s ease', 
                    boxShadow: view === 'inventory' ? '0 4px 10px rgba(236, 72, 153, 0.2)' : 'none' 
                }}>
                    <ClipboardList size={20} color={view === 'inventory' ? '#F472B6' : '#64748B'} strokeWidth={view === 'inventory' ? 2.5 : 2} />
                </div>
                <span style={{ fontSize: '9px', color: view === 'inventory' ? '#F472B6' : '#64748B', fontWeight: '700', letterSpacing: '0.3px', textTransform: 'uppercase' }}>Stock</span>
            </div>
            
            {/* JOBS / VACANCIES */}
            <div onClick={(e) => handleVoiceClick(
                e, " ye jobs page button hai, ismein aap apne textile karkhane ke liye job post kar sakte hain,", 
                () => { setView('vacancies'); setShowGuideModal(false); },
                'nav-jobs', view === 'vacancies', 
                " aap abhi jobs page par hain, ismein aap apne textile karkhane ke liye job post kar sakte hain."
            )} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', cursor: 'pointer', transition: 'all 0.2s', transform: view === 'vacancies' ? 'translateY(-2px)' : 'none' }}>
                <div style={{ 
                    background: view === 'vacancies' ? 'rgba(249, 115, 22, 0.15)' : 'transparent', 
                    border: view === 'vacancies' ? '1px solid rgba(249, 115, 22, 0.3)' : '1px solid transparent',
                    padding: '6px 14px', borderRadius: '14px', transition: 'all 0.3s ease', 
                    boxShadow: view === 'vacancies' ? '0 4px 10px rgba(249, 115, 22, 0.2)' : 'none' 
                }}>
                    <UserPlus size={20} color={view === 'vacancies' ? '#FB923C' : '#64748B'} strokeWidth={view === 'vacancies' ? 2.5 : 2} />
                </div>
                <span style={{ fontSize: '9px', color: view === 'vacancies' ? '#FB923C' : '#64748B', fontWeight: '700', letterSpacing: '0.3px', textTransform: 'uppercase' }}>Jobs</span>
            </div>

        </div>
    );
};

export default BottomNav;